import React from "react";
import { Typography, Input, Form } from "antd";
import { NUMBER_WITH_COMMA } from "Misc/constants";
import "./style.scss";

const { Text } = Typography;

const CamposParametros = (props) => {
  const {
    isDesejavel,
    nome,
    label,
    valores,
    unidade,
    readOnly,
    codigoOperador,
    outliers = [],
  } = props;
  const { getFieldDecorator, getFieldValue } = props.form;

  const id = isDesejavel ? "idDesejavel" : "id";
  const value = isDesejavel ? "valoresDesejaveis" : "valores";
  const isBetween = codigoOperador === "between";
  const numberWithCommaPattern = new RegExp(NUMBER_WITH_COMMA.source);

  const normalizeNumericValue = (rawValue) => {
    if (rawValue === undefined || rawValue === null) return "";
    return String(rawValue).trim().replace(".", ",");
  };

  const parseNumericValue = (rawValue) => {
    const normalized = normalizeNumericValue(rawValue);
    if (!normalized || !numberWithCommaPattern.test(normalized)) return null;
    return Number(normalized.replace(",", "."));
  };

  const validateOutliers = (value, unidade) => {
    const listOutliers = Array.isArray(outliers) ? outliers : [];
    const findParam = listOutliers.find(
      (parametro) => +parametro.idParametroSaude === +props.idParametro
    );
    if (!findParam || !value) return;

    if (value) {
      const newValue = value.replace(',', '.')
      if (+newValue > +findParam.valorMaximo || +newValue < +findParam.valorMinimo) {
        return Promise.reject(
          new Error(`Valor mín. possível de ${findParam.valorMinimo} ${unidade} e o máx. de ${findParam.valorMaximo} ${unidade}`)
        );
      }
    }
  };

  return (
    <div
      className="spacing-sections"
      style={isBetween ? { gridColumn: "1 / -1" } : {}}
    >
      <Text style={{ fontWeight: "bold" }}>{nome || null}</Text>
      {!isBetween ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "start",
            justifyContent: "flex-start",
          }}
        >
          <Text style={{ lineHeight: "42px" }}>
            <i>{label}</i>
          </Text>
          <Form.Item key="input-parametro-frequencia-1">
            {getFieldDecorator(
              `parametrosSaude[${props.idParametro}][subitem][${id}:${props.idSubitem}][${value}][0]`,
              {
                rules: [
                  {
                    required: !isDesejavel,
                    message: "Insira um valor válido!",
                  },
                  {
                    validator: async (rules, value) => {
                      if (!value) return;

                      const numericValue = parseNumericValue(value);
                      if (numericValue === null) {
                        return Promise.reject(new Error("Insira um valor válido!"));
                      }

                      if (isDesejavel && +props.idSubitem === 21) {
                        const alarmValue = getFieldValue(
                          `parametrosSaude[${props.idParametro}][subitem][${id}:22][valoresDesejaveis][0]`
                        );
                        const numericAlarmValue = parseNumericValue(alarmValue);
                        if (numericAlarmValue !== null && numericValue >= numericAlarmValue) {
                          return Promise.reject(
                            new Error(`Insira um valor menor que ${alarmValue}`)
                          );
                        }
                      }
                      return validateOutliers(value, unidade);
                    },
                  },
                ],
                initialValue: valores[0],
                normalize: (value) => {
                  return value && value.includes(".")
                    ? value.replace(".", ",")
                    : value;
                },
              }
            )(
              <Input
                className="input-health-params"
                addonAfter={unidade}
                disabled={readOnly}
              />
            )}
          </Form.Item>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "start",
            justifyContent: "flex-start",
          }}
        >
          <Text style={{ lineHeight: "42px" }}>{label}</Text>
          <Form.Item key="input-parametro-frequencia-2">
            {getFieldDecorator(
              `parametrosSaude[${props.idParametro}][subitem][${id}:${props.idSubitem}][${value}][0]`,
              {
                rules: [
                  {
                    required: !isDesejavel,
                    message: "Insira um valor válido!",
                  },
                  {
                    validator: async (rules, value) => {
                      if (!value) return;

                      const numericValue = parseNumericValue(value);
                      if (numericValue === null) {
                        return Promise.reject(new Error("Insira um valor válido!"));
                      }

                      return validateOutliers(value, unidade);
                    },
                  },
                ],
                initialValue: valores[0],
                normalize: (value) => {
                  return value && value.includes(".")
                    ? value.replace(".", ",")
                    : value;
                },
              }
            )(
              <Input
                className="input-health-params"
                addonAfter={unidade}
                disabled={readOnly}
              />
            )}
          </Form.Item>
          <Text style={{ lineHeight: "42px" }}> e </Text>
          <Form.Item key="input-parametro-frequencia-3">
            {getFieldDecorator(
              `parametrosSaude[${props.idParametro}][subitem][${id}:${props.idSubitem}][${value}][1]`,
              {
                rules: [
                  {
                    message: "Insira um valor válido!",
                    validator: async (rule, value) => {
                      if (!value) return;

                      const numericValue = parseNumericValue(value);
                      if (numericValue === null) {
                        return Promise.reject(new Error("Insira um valor válido!"));
                      }

                      const minDesireableValue =
                        getFieldValue(
                          `parametrosSaude[${props.idParametro}][subitem][${id}:${props.idSubitem}][${value}][0]`
                        );

                      const numericMinDesireableValue = parseNumericValue(minDesireableValue);
                      if (
                        numericMinDesireableValue !== null &&
                        numericValue <= numericMinDesireableValue
                      )
                        return Promise.reject(
                          new Error(
                            `Insira um valor maior que ${minDesireableValue}`
                          )
                        );
                        return validateOutliers(value, unidade);
                    },
                  },
                ],
                initialValue: valores[1],
                normalize: (value) => {
                  return value && value.includes(".")
                    ? value.replace(".", ",")
                    : value;
                },
              }
            )(
              <Input
                className="input-health-params"
                addonAfter={unidade}
                disabled={readOnly}
              />
            )}
          </Form.Item>
        </div>
      )}
    </div>
  );
};

export default CamposParametros;

// Helper para converter nomes de campos em labels amigáveis
export function getFieldLabel(fieldName) {
  if (fieldName === "horario") return "Melhor horário para acompanhamento";
  if (fieldName.includes('id:1')) return 'Pressão arterial';
  if (fieldName.includes('id:4')) return 'Glicemia';
  if (fieldName.includes('id:6')) return 'Temperatura';
  if (fieldName.includes('idDesejavel:21')) return 'Pressão arterial desejável';
  if (fieldName.includes('idDesejavel:23')) return 'Glicemia desejável';
  if (fieldName.includes('idDesejavel:25')) return 'Temperatura desejável';
  if (fieldName.includes('idDesejavel:24')) return 'Outro parâmetro desejável';
  if (fieldName.includes('idDesejavel:27')) return 'Outro parâmetro desejável';
  return fieldName;
}

function getFieldHint(message, fieldName) {
  if (fieldName === "horario") {
    return "Informe o horário no formato HH:mm (ex: 08:30).";
  }

  const invalidNumberMessage =
    message === "Insira um valor válido!" || message === "Formato invalido";

  if (invalidNumberMessage) {
    return "Informe apenas números; para decimal use vírgula (ex: 120 ou 120,5).";
  }

  return message;
}

function formatFieldValue(rawValue) {
  if (rawValue === undefined || rawValue === null || rawValue === "") {
    return "(vazio)";
  }

  if (Array.isArray(rawValue)) {
    const arrayValue = rawValue
      .map((item) => (item === undefined || item === null || item === "" ? "(vazio)" : String(item)))
      .join(", ");
    return arrayValue || "(vazio)";
  }

  if (typeof rawValue === "object") {
    try {
      return JSON.stringify(rawValue);
    } catch (error) {
      return "[objeto]";
    }
  }

  return String(rawValue);
}

export function showValidationErrors(errors) {
  const readableErrors = errors.map((err) => {
    const label = getFieldLabel(err.field || "");
    const hint = getFieldHint(err.message, err.field || "");
    const value = formatFieldValue(err.value);
    return { label, hint, value };
  });

  const uniqueErrors = [];
  const seen = new Set();

  readableErrors.forEach((err) => {
    const key = `${err.label}-${err.hint}-${err.value}`;
    if (!seen.has(key)) {
      seen.add(key);
      uniqueErrors.push(err);
    }
  });

  return uniqueErrors;
}
